import React from 'react'
import TextBox from './TextBox';
import Dropdown from './Dropdown';
import Calendar from './Calendar';

const Components ={
    1:TextBox,
    2:Dropdown,
    3:Calendar,
  }
  
  export const WithInputType = (props) =>{
    if(!Components[props.fieldType]){
      return <TextBox {...props} />
    }
    let ComponentName = Components[props.fieldType];
    return <ComponentName {...props}/>
  } 
